// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @14.07.2017 13:53:29
import { CCallerHistory_abstract } from './../../abstract/SagaSchema/History/CCallerHistory_abstract';
export class CCallerHistory extends CCallerHistory_abstract {}
